import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../Components/Common/Loader";
import OwnerSilkImageManagerModal from "../../Components/Common/OwnerSilkImageManagerModal";
import {
  deleteOwnerSilkImageById,
  MAX_OWNER_SILK_IMAGES,
  uploadTempOwnerSilkImages,
} from "../../Components/Common/ownerSilkImagesApi";

const OwnerColor = () => {
  const { state } = useLocation();
  const routeOwner = state?.ownerid;
  const ownerId = routeOwner?._id || routeOwner;
  const history = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [ownerSilkImages, setOwnerSilkImages] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);

  useEffect(() => {
    const loadSilkImages = async () => {
      if (!ownerId) return;
      try {
        const response = await axios.get(
          `${window.env.API_URL}/GetSilkColorOfOwner/${encodeURIComponent(ownerId)}`
        );
        const backendSilkImages = response.data?.data || [];
        const hasDefault = backendSilkImages.some((item) => !!item.isDefault);
        const normalized = backendSilkImages.map((item, index) => ({
          _id: item._id,
          image: item.OwnerSilkColor || item.image,
          DescriptionEn: item.DescriptionEn || "",
          DescriptionAr: item.DescriptionAr || "",
          isDefault: hasDefault ? !!item.isDefault : index === 0,
          isTemporary: !!item.isTemporary,
        }));
        setOwnerSilkImages(normalized);
      } catch (error) {
        setOwnerSilkImages([]);
      }
    };
    loadSilkImages();
  }, [ownerId]);

  const normalizeAndSetSilkImages = (backendSilkImages) => {
    const hasDefault = backendSilkImages.some((item) => !!item.isDefault);
    const normalized = backendSilkImages.map((item, index) => ({
      _id: item._id,
      image: item.OwnerSilkColor || item.image,
      DescriptionEn: item.DescriptionEn || "",
      DescriptionAr: item.DescriptionAr || "",
      isDefault: hasDefault ? !!item.isDefault : index === 0,
      isTemporary: !!item.isTemporary,
    }));
    setOwnerSilkImages(normalized);
  };

  const uploadSilkImages = async (files) => {
    setUploadInProgress(true);
    setUploadProgress(0);
    try {
      const uploaded = await uploadTempOwnerSilkImages(files, (event) => {
        const percent = Math.round((event.loaded * 100) / (event.total || 1));
        setUploadProgress(percent);
      });
      return uploaded;
    } finally {
      setUploadInProgress(false);
      setUploadProgress(0);
    }
  };

  const deleteRemoteSilkImage = async (imageId) => {
    if (!imageId) return;
    await deleteOwnerSilkImageById(imageId);
  };

  const submitSilkColor = async () => {
    if (!ownerId) {
      swal("Error!", "Owner id is missing.", "error");
      return;
    }
    if (uploadInProgress) {
      swal("Error!", "Please wait for image upload to complete.", "error");
      return;
    }
    if (deleteInProgress) {
      swal("Error!", "Please wait for image deletion to complete.", "error");
      return;
    }
    if (ownerSilkImages.length < 1) {
      swal("Error!", "At least one owner silk image is required.", "error");
      return;
    }
    if (ownerSilkImages.length > MAX_OWNER_SILK_IMAGES) {
      swal("Error!", `You can upload maximum ${MAX_OWNER_SILK_IMAGES} images.`, "error");
      return;
    }
    if (ownerSilkImages.filter((item) => item.isDefault).length !== 1) {
      swal("Error!", "Please set exactly one default silk image.", "error");
      return;
    }

    setisLoading(true);
    try {
      const formData = new FormData();
      formData.append(
        "ownerSilkImages",
        JSON.stringify(
          ownerSilkImages.map((item) => ({
            _id: item._id,
            DescriptionEn: item.DescriptionEn || "",
            DescriptionAr: item.DescriptionAr || "",
            isDefault: !!item.isDefault,
          }))
        )
      );

      await axios.put(`${window.env.API_URL}/updateOwner/${ownerId}`, formData);
      const refreshed = await axios.get(
        `${window.env.API_URL}/GetSilkColorOfOwner/${encodeURIComponent(ownerId)}`
      );
      normalizeAndSetSilkImages(refreshed.data?.data || []);
      swal({
        title: "Success!",
        text: "Silk colors have been updated successfully",
        icon: "success",
        button: "OK",
      });
      history("/EditownerCap", {
        state: {
          ownerid: ownerId,
        },
      });
    } catch (error) {
      const err = error.response?.data?.message || "Unable to update silk colors";
      swal({
        title: "Error!",
        text: err,
        icon: "error",
        button: "OK",
      });
    } finally {
      setisLoading(false);
    }
  };

  return (
    <>
      <div className="page">
        <div className="rightsidedata">
          <div
            style={{
              marginTop: "30px",
            }}
          >
            <div className="Headers">Edit Silk Color</div>
            {isLoading ? (
              <Loader />
            ) : (
              <div className="form">
                <OwnerSilkImageManagerModal
                  images={ownerSilkImages}
                  setImages={setOwnerSilkImages}
                  onUpload={uploadSilkImages}
                  onDeleteRemote={deleteRemoteSilkImage}
                  uploadProgress={uploadProgress}
                  uploadInProgress={uploadInProgress}
                  onDeleteInProgressChange={setDeleteInProgress}
                />
                <div className="ButtonSection">
                  <div />
                  <div>
                    <button
                      className="SubmitButton"
                      onClick={submitSilkColor}
                      disabled={uploadInProgress || deleteInProgress}
                    >
                      Update Silk Color
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OwnerColor;
